var webooker_acivity_models = webooker_acivity_models || {};

(function (ns) {

    // #region ScheduleDayBase - Ctor 
    ns.ScheduleDayBase = function ScheduleDetail() {
    }
    // #endregion

    // #region ScheduleDayBase - Methods

    ns.ScheduleDayBase.prototype.normalizeDate = function (mvalue) {        
        return new Date(1970, 0, 1, mvalue.hours(), mvalue.minutes());
    }

    ns.ScheduleDayBase.prototype.getUnboundedMinTimeValue = function () {
        return moment(new Date(1970, 0, 1, 0));
    }

    ns.ScheduleDayBase.prototype.getUnboundedMaxTimeValue = function () {
        // Date(year, month, day, hour, minute, second, millisecond)
        return moment(new Date(2200, 0, 1, 23, 59, 59, 99));
    }
            
    ns.ScheduleDayBase.prototype.getMinTimeValue = function (schedules, propertyName, nullIfNoValue) {
        var minDate = this.getUnboundedMinTimeValue();
        var valueSet = false;

        if (schedules) {
            for (var d = 0; d < schedules.length; d++) {
                var prop = schedules[d][propertyName];
                if (prop) {
                    var date = moment(prop);
                    var minutes = date.hour() * 60 + date.minute();
                    var minMinutes = minDate.hour() * 60 + minDate.minute();

                    if (minutes <= minMinutes || !valueSet) {
                        minDate = date;
                        valueSet = true;
                    }
                }
            }
        }

        if (!valueSet && nullIfNoValue) {
            return null;
        }

        return this.normalizeDate(minDate);
    }

    ns.ScheduleDayBase.prototype.getMaxTimeValue = function (schedules, propertyName, nullIfNoValue) {
        var maxDate = this.getUnboundedMaxTimeValue();
        var valueSet = false;

        if (schedules) {
            for (var d = 0; d < schedules.length; d++) {
                var prop = schedules[d][propertyName];
                if (prop) {
                    var date = moment(prop);
                    var minutes = date.hour() * 60 + date.minute();
                    var maxMinutes = maxDate.hour() * 60 + maxDate.minute();

                    if (minutes >= maxMinutes || !valueSet) {
                        maxDate = date;
                        valueSet = true;
                    }
                }
            }
        }

        if (!valueSet && nullIfNoValue) {
            return null;
        }

        return this.normalizeDate(maxDate);
    }

    ns.ScheduleDayBase.prototype.getSchedulesByDay = function (sch, dayOfWeek) {
        var all = [];

        if (sch) {
            for (var w = 0; w < sch.length; w++) {
                var week = sch[w];

                // TODO: call getReservationsByDay
                for (var s = 0; s < week.schedules.length; s++) {
                    var schedule = week.schedules[s];
                    var dateIndicia = schedule.firstPeriodStartDate ||
                                      schedule.firstPeriodEndDate ||
                                      schedule.secondPeriodStartDate ||
                                      schedule.secondPeriodEndDate;

                    if (!!dateIndicia) {
                        var scheduleDayOfWeek = moment(dateIndicia).isoWeekday();

                        if (scheduleDayOfWeek === dayOfWeek) {
                            all.push(schedule);
                        }
                    }
                }
            }
        }

        return all;
    }

    ns.ScheduleDayBase.prototype.isTimeIndeterminate2 = function (daySchedules, propertyName, value, min) {
        if (!daySchedules || !daySchedules.length || !value) {
            return false;
        }

        var valueDate = moment(value);
        var valueMin = valueDate.hours() * 60 + valueDate.minutes();

        for (var s = 0; s < daySchedules.length; s++) {
            var daySchedule = daySchedules[s];
            var scheduleValue = daySchedule[propertyName];
            if (!scheduleValue) {
                return true;
            }

            var schDate = moment(scheduleValue);
            var schMin = schDate.hours() * 60 + schDate.minutes();

            if (min) {
                if (schMin > valueMin) {
                    return true;
                }
            } else {
                if (schMin < valueMin) {
                    return true;
                }
            }
        }

        return false;
    }

    ns.ScheduleDayBase.prototype.isBoolIndeterminate2 = function (daySchedules, propertyName, value) {
        if (!daySchedules || !daySchedules.length || value === undefined || value === null) {
            return false;
        }

        for (var s = 0; s < daySchedules.length; s++) {
            var daySchedule = daySchedules[s];
            var scheduleValue = daySchedule[propertyName];
            if (value && !scheduleValue) {
                return true;
            }
        }

        return false;
    }



    // #endregion

}(webooker_acivity_models));